import firebase from 'firebase'
import 'firebase/firestore'

// firebase init
const devConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_DEV_APIKEY,
    authDomain: process.env.VUE_APP_FIREBASE_DEV_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DEV_DATABASEURL,
    projectId: process.env.VUE_APP_FIREBASE_DEV_PROJECTID,
    storageBucket: process.env.VUE_APP_FIREBASE_DEV_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_DEV_MESSAGINGSENDERID,
}

const prodConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASEURL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
}

const config = process.env.NODE_ENV == 'production' ? prodConfig : devConfig
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// firebase collections
// const usersCollection = db.collection('users')
// const postsCollection = db.collection('posts')
// const commentsCollection = db.collection('comments')
// const likesCollection = db.collection('likes')

export {
    db,
    auth,
    currentUser
    // usersCollection,
    // postsCollection,
    // commentsCollection,
    // likesCollection
}